/* eslint-env browser */

(() => {
	const hljsJS = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.0.2/highlight.min.js';
	const hljsCSS = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.0.2/styles/github.min.css';
	const hljsJSSum = 'L4YmspWgHJZskI6evyHCF/cfTWSShsnzGAYcJCS9xR2G2y4FEB5VbmNYGow27AJ6';
	const hljsCSSSum = 'yaOEEinoAKxVHv1ZCY3vqJeRItlRVwZ9pyTCCJLHlyHNndGZIF+S30C1+8oRQ2sz';

	const loaded = new Map();

	function script(src, sum, cb) {
		if (loaded.has(src)) return Promise.resolve(src);

		return new Promise((resolve, reject) => {
			const scriptElem = document.createElement('script');
			style.integrity = 'sha384-' + sum;
			scriptElem.defer = true;
			scriptElem.src = src;
			scriptElem.onload = resolve;
			scriptElem.onerror = reject;
			document.body.appendChild(scriptElem);
		}).then((res) => {
			const val = (cb) ? cb(res) : res;
			loaded.set(src, val);
			return val;
		});
	}

	function style(src, sum) {
		return new Promise((resolve, reject) => {
			const styleElem = document.createElement('link');
			styleElem.rel = 'stylesheet';
			style.integrity = 'sha384-' + sum;
			styleElem.href = src;
			styleElem.onload = resolve;
			styleElem.onerror = reject;
			document.body.appendChild(styleElem);
		});
	}

	function applyHLJS(hljs) {
		document.querySelectorAll('pre code').forEach((code) => {
			hljs.highlightBlock(code);
		});
	}


	style(hljsCSS, hljsCSSSum);
	script(hljsJS, hljsJSSum, () => window.hljs).then(applyHLJS);
})();
